import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box, Container, Grid, Typography, Divider } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import Link from 'next/link';

// import svgs
import map from '/public/svgs/map.svg';

// utils
import useWindowSize from '/utils/useWindowSize';

import Logo from '/components/layouts/Logo';
import Contact from '/components/layouts/Contact';
import Whitebttn from '/components/layouts/Whitebttn';

// store
import { GlobalContext } from '/context';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundImage: 'url("/home/footer.png")', // Зургийн зам
        backgroundSize: 'cover', // Контейнерт багтаах
        backgroundPosition: 'center', // Голд нь байрлуулах
        backgroundRepeat: 'no-repeat', // Давтагдахгүй
        width: '100%',
        height: 380, // Өндрийг тохируулах
    },

    footerBox: (props) => {
        return {
            justifyContent: 'center',
            display: 'flex',
        };
    },
    boxCss: (props) => {
        return {
            // width: '100%',
            // width: 545,
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: 370,
        };
    },
    footerTitle: {
        color: '#FFFFFF',
        fontSize: 22,
        fontWeight: 700,
        marginBottom: 17,
        fontFamily: 'Roboto, sans-serif',
        lineHeight: '25.78px',
    },
    footerText: {
        fontSize: 14,
        fontWeight: 700,
        fontFamily: 'Roboto, sans-serif',
        lineHeight: '16.41px',
        marginBottom: 10,
        color: '#FFFFFF',
        cursor: 'pointer',
    },
    developed: {
        backgroundColor: '#2E3192',
        maxWidth: '100%',
        textAlign: 'center',
        paddingTop: 20,
        paddingBottom: 20,
    },
    footer: {
        flexDirection: 'column',
    },
}));

const Footer = () => {
    const { state } = useContext(GlobalContext);
    const [organ, setOrgan] = useState([]);
    const [team, setTeam] = useState([]);
    const { width } = useWindowSize();
    const classes = useStyles({ windowsize: width });

    return (
        <>
            {' '}
            <Box className={classes.root}>
                {/* <div className={classes.footerBox}> */}
                <Box className={classes.boxCss}>
                    <Logo
                        logo="white"
                        textcolor="white"
                        position="footer"
                        className={classes.footer}
                        marginbottom="10px"
                        text2Height="30px"
                        height="130"
                        width="130"
                    />
                    <Contact windowsize={width} />
                    <Box class="w-[354px] text-center mt-5">
                        <Typography variant="h5" style={{ marginTop: 10, color: '#FFFFFF' }}>
                            Хаяг: 16081, УБ хот, БГД, 5 дугаар хороо, Ард Аюушийн гудамж 1а,
                            ШУГТЭ-ийн 1 давхарт
                        </Typography>
                    </Box>

                    {/* <Whitebttn windowsize={width} type="footer" /> */}
                </Box>
                {/* </div> */}
            </Box>
            <Container className={classes.developed}>
                <Box>
                    <Typography
                        variant="body1"
                        style={{ marginLeft: 10, fontWeight: '700', color: '#FFFFFF' }}
                    >
                        © {new Date().getFullYear()} Т.Шагдарсүрэнгийн нэрэмжит Анагаах Ухааны
                        Хүрээлэн
                    </Typography>
                </Box>
            </Container>
        </>
    );
};

Footer.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func,
};

export default Footer;
